// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    appName: 'Cross Platform Integration Console (Dev)',
    lsiEndpointApiKey: 'o8iyqfj2YM4MEfE4UtrZKak9hs69agZQ6x9FLN8e',
    unifiedQueryV2EndPoint:
        'https://api.genlogic.co.th/dev/v2/internal/unified-query',
    TiktokDelegateEndPoint:
        'https://api.genlogic.co.th/dev/internal/tiktok/delegate',
    shopeeDelegateV2EndPoint:
        'https://api.genlogic.co.th/dev/v2/internal/shopee/delegate',
    lazadaDelegateEndPoint:
        'https://api.genlogic.co.th/dev/internal/lazada/delegate',
    lastPrintEndPoint: 'https://api.genlogic.co.th/dev/internal/last-print',
    renderReportEndpoint:
        'https://api.genlogic.co.th/dev/internal/report/render',
    renderReportFunctionName:
        'arn:aws:lambda:ap-southeast-7:707498625607:function:genlogic-jsreport-RenderFunction-oyVLNUyYMwzb',
    outputTaxEndpoint: 'https://api.genlogic.co.th/dev/internal/tax/output-tax',
    financeTxEndpoint: 'https://api.genlogic.co.th/dev/internal/finance/tx',
    returnsEndpoint: 'https://api.genlogic.co.th/dev/internal/returns',
    ssmGetEndpoint: 'https://api.genlogic.co.th/dev/internal/ssm/get',
    saleSinceEndpoint:
        'https://api.genlogic.co.th/dev/internal/analytics/sale-since',
    lastSaleEndpoint:
        'https://api.genlogic.co.th/dev/internal/analytics/last-sale',
    abcAnalysisEndpoint:
        'https://api.genlogic.co.th/dev/internal/analytics/abc',
    renderPersistReportEndpoint:
        'https://api.genlogic.co.th/dev/internal/report/render-persist',
    ropEndpoint: 'https://api.genlogic.co.th/dev/internal/reordering/rop',
    eoqingEndpoint: 'https://api.genlogic.co.th/dev/internal/reordering/eoq',
    reorderingConfigEndpoint:
        'https://api.genlogic.co.th/dev/internal/reordering/config',
    scraperApiEndpoint: 'https://api.genlogic.co.th/dev/internal/scraper',
    vcbTaxInvReqGetProductEndpoint:
        'https://api.genlogic.co.th/dev/internal/tax/vcb-tax-inv-req/get-products',
    vcbTaxInvReqCreateFormEndpoint:
        'https://api.genlogic.co.th/dev/internal/tax/vcb-tax-inv-req/create-form',
    vcbTaxInvReqUpsertShortNameEndpoint:
        'https://api.genlogic.co.th/dev/internal/tax/vcb-tax-inv-req/upsert_pshort',
    inventoryMarkEndpoint:
        'https://api.genlogic.co.th/dev/internal/inventory/mark',
    priceCalSaveEndpoint:
        'https://api.genlogic.co.th/dev/internal/analytics/price-cal',
    invoiceRequestApiEndpoint:
        'https://uv5u3unl2a.execute-api.ap-southeast-7.amazonaws.com',
    invoiceRequestApiKey: 'nK8RiOWI5CG1xIjJCoO_6R2R5Ljr8vA9',
    ninjaLogoUrl:
        'https://genlogic-web-resources.s3.ap-southeast-7.amazonaws.com/jsreport-resources/ninjavan_logo.png',
    kerryLogoUrl:
        'https://genlogic-web-resources.s3.ap-southeast-7.amazonaws.com/jsreport-resources/kerry_logo.png',
    flashLogoUrl:
        'https://genlogic-web-resources.s3.ap-southeast-7.amazonaws.com/jsreport-resources/flash_logo.jpg',
    shopeeExpressLogoUrl:
        'https://genlogic-web-resources.s3.ap-southeast-7.amazonaws.com/jsreport-resources/shopeeexpress_logo.png',
    jtLogoUrl:
        'https://genlogic-web-resources.s3.ap-southeast-7.amazonaws.com/jsreport-resources/jt_logo.png',
    spxLogoUrl:
        'https://genlogic-web-resources.s3.ap-southeast-7.amazonaws.com/jsreport-resources/spx_logo.png',
    invoiceReportTemplateName: 'invoice',
    taxInvoiceReportTemplateName: 'tax-invoice',
    outputTaxReportTemplateName: 'output-tax',
    shopeeeShippingLabelReportTemplateName: 'shopee-shipping-label',
    lazadaShipingLabelRenderTemplateName: 'laz-shipping-label-render',
    quoteTemplateName: 'quote',
    deliveryNoteTemplateName: 'delivery-note',
    receiptNoteTemplateName: 'receipt-note',
    // Archive folder for issued temporary delivery notes. Entity-independent
    // on purpose: the document carries no VAT and opens no RD audit trail, so
    // unlike the per-entity folders on entity-config.ts's registered entities
    // it does not have to be handed over one tree at a time.
    tempDeliveryNoteDriveFolderId: '1XoPa0ma66RF3tHzi_434cMkrwJthk9zV',
    // Archive folder for receipts issued against marketplace orders. Same
    // reasoning as the delivery-note folder: no VAT, no RD audit trail, so one
    // entity-independent folder. Shared with the render-persist Lambda's
    // uploader service account on 2026-08-21 — a folder that is not shared
    // with it fails as Drive "File not found: <id>".
    receiptNoteDriveFolderId: '1Du3bHl_txxY1VsEVcNpbml2gFP6-sfZ4',
    // The seller/sender address printed on invoices and shipping labels. Lives
    // here rather than in store-config because it is the one printed value that
    // differs between builds. Everything else a store prints — trading name,
    // storefront URL, tax id — is declared per store in
    // src/app/shared/config/store-config.ts.
    reportSenderAddress:
        '111/12 ซ.โชคชัยร่วมมิตร ถนนวิภาวดีรังสิต แขวงจอมพล เขตจตุจักร กรุงเทพ 10900',
    printDateFormat: 'D MMM YYYY',
    googleApiClientId:
        '292357845356-lr37tkhk6upahdhivud7hk89p5debtqv.apps.googleusercontent.com',
    googleApiKey: 'AIzaSyBHqfJ8332cn2QCJkEczfR75S1ekgnDbmk',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
